export default {
    "ERROR": {
        "GENERAL": "Error",
        "TOOMANYREQUEST": "Too many requests",
        "APIERROR": "API Error",
        "APIDEPLOY": "API deploy in progress",
        "FAILED": "Failed",
        "INVALID_ARTIST_NAME": "Invalid artist name",
        "NO_ARTIST_NAME": "Invalid artist name",
        "INVALID_PLACE_NAME": "Invalid location",
        "NO_PLACE_NAME": "Invalid location",
        "INVALID_START_DATE": "Invalid date",
        "LINE_NR": "{line}. Line",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/en/error.js